import { api } from '@services/api'
import { toSearchParams } from '@utils/search'
import { Menu, ApiScope, Scope, MenuResponse, Menus } from './types'
export * from './types'

const scopes = {
  navbar: 'main',
  footer1: 'footer1',
  footer2: 'footer2'
}

const filterByScope = (menus: Menu[], scope: ApiScope) =>
  menus.filter(menu => menu.scope === scope)

export const index = (scope?: Scope) => {
  const query: any = {}

  if (scope) {
    query.scope = scopes[scope]
  }

  return api.get<MenuResponse>('/menus', { params: toSearchParams(query) })
}

export const all = async (): Promise<Menus> => {
  const {
    data: { menus }
  } = await index()

  return {
    main: filterByScope(menus, ApiScope.MAIN),
    footer1: filterByScope(menus, ApiScope.FOOTER1),
    footer2: filterByScope(menus, ApiScope.FOOTER2),
    editorial_summary: filterByScope(menus, ApiScope.EDITORIAL_SUMMARY)
  }
}

export const MenusApi = {
  index,
  all
}
